export default "__VITE_ASSET__BCEaE2cN__"